module.exports = "/call-frontend/img/trans_gpt-title.160e1d9c.png";